import { IconName, MemreFlexBox, MemreIcon, MemreText } from 'components/core';

export default function NoInteraction() {
  return (
    <MemreFlexBox align="center" justify="center" sx={{ h: '100%', width: '100%' }}>
      <MemreFlexBox gap={2} direction="column">
        <MemreIcon iconName={IconName.circleXmark} fontSize="2em" color="#333" />
        <MemreText>No items selected</MemreText>
      </MemreFlexBox>
    </MemreFlexBox>
  );
}
